<template>
	<v-menu
		:close-on-content-click="true"
		v-if="item.Children"
		offset-y
		v-model="menuStatus"
	>
		<template #activator="{ value }">
			<div @click="toggleDropdown" style="cursor: pointer">
				<span style="cursor: pointer" class="primary--text">{{
					item.Title
				}}</span>
				<v-icon v-if="value">mdi-menu-up</v-icon>
				<v-icon v-else>mdi-menu-down</v-icon>
			</div>
		</template>
		<v-list>
			<v-list-item
				v-for="(child, i) in item.Children"
				:key="`item-${i}`"
				:item="child"
				@click="$router.push(child.Path)"
			>
				<span v-if="child.Title == item.Title" class="primary--text">{{
					child.Title
				}}</span>
				<span v-else>{{ child.Title }}</span>
			</v-list-item>
		</v-list>
	</v-menu>
</template>
<script>
export default {
	name: 'BreadcrumbDropdown',
	props: {
		item: Object,
		pageName: String,
	},
	data() {
		return { menuStatus: false };
	},
	methods: {
		toggleDropdown() {
			if (this.menuStatus) this.menuStatus = false;
			else this.menuStatus = true;
		},
	},
};
</script>
